import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/images/close.svg'


const _hoisted_1 = {
  class: "modal",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "card invitations-card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.props.hasCloseButton)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _imports_0,
                  class: "close-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeThis()))
                }))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ])
        ])
      ])
    ])
  ]))
}